const TravelOverview = () => import('@/views/dashboard/types/DashboardType1');
const TravelNews = () => import('@/views/dashboard/types/DashboardType2');
const VoiceOfCustomer = () => import('@/views/dashboard/types/DashboardType3');
const Domestic = () => import('@/views/dashboard/types/DashboardType4');
const ForeignMarket = () => import('@/views/dashboard/types/DashboardType5');
const SpaceAvailability = () => import('@/views/dashboard/types/DashboardType6');
const Competitor = () => import('@/views/dashboard/types/DashboardType7');
const ImmigrationCheckpoint = () => import('@/views/dashboard/types/DashboardType8');

const mainDashboard = [
  // {
  //   title: 'My Dashboard',
  //   path: '/admin/dashboard/my-dashboard',
  //   component: MyDashboard
  // },
  // {
  //   path: "/admin",
  //   name: "Dashboard",
  //   redirect: "/admin/dashboard/travel-overview"
  // },
  {
    title: 'Dashboard-Travel Overview',
    path: '/admin/dashboard/travel-overview',
    component: TravelOverview // no. 1
  },
  {
    title: 'Dashboard-Travel News',
    path: '/admin/dashboard/travel-news',
    component: TravelNews // no. 2
  },
  {
    title: 'Dashboard-Voice Of Customer',
    path: '/admin/dashboard/voice-of-customer',
    component: VoiceOfCustomer // no. 3
  },
  {
    title: 'Dashboard-Domestic',
    path: '/admin/dashboard/domestic',
    component: Domestic, // no. 4
    children: [
      {
        title: 'Domestic-Region',
        path: '/admin/dashboard/domestic/:region',
        component: Domestic,
        children: [
          {
            title: 'Domestic-Province',
            path: '/admin/dashboard/domestic/:region/:province',
            component: Domestic,
          } 
        ]
      }
    ]
  },
  {
    title: 'Dashboard-Foreign Market',
    path: '/admin/dashboard/foreign-market',
    component: ForeignMarket, // no. 5
    children: [
      {
        title: 'Foreign Market Region',
        path: '/admin/dashboard/foreign-market/:region',
        component: ForeignMarket,
        children: [
          {
            title: 'Foreign Market Country',
            path: '/admin/dashboard/foreign-market/:region/:country',
            component: ForeignMarket,
          } 
        ]
      }
    ]
  },
  {
    title: 'Dashboard-Space Availability',
    path: '/admin/dashboard/space-availability',
    component: SpaceAvailability // no. 6
  },
  {
    title: 'Dashboard-Competitor',
    path: '/admin/dashboard/competitor',
    component: Competitor // no. 7
  },
  {
    title: 'Dashboard-Immigration Checkpoint',
    path: '/admin/dashboard/immigration-checkpoint',
    component: ImmigrationCheckpoint // no. 8
  }
]

const routerDashboard = mainDashboard.map(data => {
  const { path, title, component, children } = data

  return {
    path: path,
    name: title,
    component: component,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})

export {
  routerDashboard
}
